const state = {
  dbRefLoader: true,
  firestore: {},
  storage: {}
}

const getters = {
  dbRefLoader: state => state.dbRefLoader
}

const mutations = {
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dbRefs.js